// Programme 3 semaines — 5 min/jour (Observer → Analyser → Ajuster).
// Carnet interactif bilingue FR/ES. Progression enregistrée localement (localStorage).

export const PROGRAMME_IMG = "https://images.unsplash.com/photo-1564510714747-69c3bc1fab41?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
export const PROGRAMME_KEY = "m2hat_programme_progress";
export const PROG_DAYS = 7;

export const PROG_T = {
  fr: {
    allModules: "← Tous les modules",
    welcomeTitle: "Programme 3 semaines — 5 min/jour",
    welcomeText: "Un programme pensé pour votre cerveau — pas contre lui. Pas de perfection, pas d'organisation militaire, pas de méthode miracle. Juste 5 minutes par jour pour moins de surcharge, plus de clarté et des actions réalistes.",
    philoTitle: "En trois mots",
    philo: ["Moins de surcharge", "Plus de clarté", "Actions réalistes"],
    start: "Commencer",
    resumeTitle: "Reprendre où vous en étiez",
    resumeBtn: "Reprendre",
    startOver: "Recommencer depuis le début",
    // Avant de commencer
    avantTitle: "Avant de commencer",
    avantNotTitle: "On NE cherche PAS",
    avantNot: ["À devenir une machine productive", "À être parfait(e)", "À tout régler en 3 semaines", "À supprimer toutes les difficultés"],
    avantSeekTitle: "On cherche à",
    avantSeek: ["Réduire la charge mentale", "Mieux gérer les priorités", "Diminuer la culpabilité", "Avancer même imparfaitement"],
    avantNext: "Commencer la semaine 1",
    // navigation
    weekWord: "Semaine",
    dayWord: "Jour",
    of: "sur",
    prev: "Précédent",
    next: "Suivant",
    otherPlaceholder: "Autre…",
    dayNotePlaceholder: "Une note pour aujourd'hui (facultatif)…",
    saved: "Progression enregistrée sur cet appareil",
    localTitle: "Vos semaines restent sur cet appareil",
    localText: "Rien n'est envoyé sur un serveur : vos réponses sont enregistrées uniquement dans ce navigateur, sur cet appareil. La conservation des semaines enregistrées dépend donc de vous : si vous changez d'appareil ou de navigateur, effacez les données de navigation ou utilisez une fenêtre privée, la progression ne sera pas retrouvée. Pensez à télécharger le carnet (PDF) à la fin de chaque semaine pour en garder une trace.",
    // Semaine 1
    w1Title: "Semaine 1 — Observer sans juger",
    w1Intro: "Observez votre quotidien sans chercher à tout analyser. Le but : repérer les moments positifs, identifier les moments difficiles et mieux percevoir votre fonctionnement réel. Sans jugement.",
    dailyRule: "5 minutes maximum — pas plus, pas moins.",
    w1PositifTitle: "Ce qui a été facile / positif",
    w1Positif: ["J'ai réussi à commencer", "Moment calme", "Bonne énergie", "Discussion agréable", "Tâche avancée"],
    w1NegatifTitle: "Ce qui a été difficile / négatif",
    w1Negatif: ["Fatigue", "Surcharge", "Procrastination", "Distractions", "Trop de pression"],
    w1EnergyTitle: "Énergie mentale du jour",
    w1EnergyHint: "Notez votre niveau d'énergie de 0 à 10.",
    w1ChargeTitle: "Charge mentale du jour",
    w1ChargeHint: "À quel point votre tête était-elle « pleine » aujourd'hui ? (0 = légère, 10 = saturée)",
    chargeWord: "Charge",
    w1VictoireTitle: "Une petite victoire",
    w1Victoire: ["Répondu à un message", "Pris une douche", "Demandé de l'aide", "Repris après une pause"],
    toBilan: "Voir le bilan de la semaine",
    // Bilan S1
    bilan1Title: "Fin de Semaine 1 — Bilan",
    bilan1Text: "Prenez quelques minutes pour repérer les patterns de votre semaine d'observation.",
    bilan1Steps: [
      { t: "Repérer", d: "Identifier les patterns récurrents" },
      { t: "Analyser", d: "Moments faciles et difficiles de la semaine" },
      { t: "Choisir", d: "4 micro-ajustements réalistes" },
    ],
    bilan1PatternsLabel: "Les patterns que je remarque",
    bilan1PatternsPh: "Ce qui revient souvent, en positif comme en difficile…",
    bilan1AjustLabel: "Mes 4 micro-ajustements pour la semaine suivante",
    bilan1AjustPh: "Micro-ajustement",
    bilan1Closing: "Ce bilan n'est pas un examen. C'est une boussole pour mieux comprendre votre cerveau.",
    toWeek2: "Passer à la semaine 2",
    // Semaine 2
    w2Title: "Semaine 2 — Analyser ses habitudes",
    w2Intro: "Comprenez ce qui aide, freine ou bloque réellement votre fonctionnement. Le but n'est pas de se juger, mais de mieux comprendre ses habitudes.",
    w2FacilitantTitle: "Ce qui a été facilitant",
    w2FacilitantHint: "Ce qui a aidé à commencer, avancer, rester concentré ou terminer.",
    w2Facilitant: ["Musique", "Timer", "Environnement calme", "Présence de quelqu'un", "Tâche découpée"],
    w2EmpechantTitle: "Ce qui a été empêchant",
    w2EmpechantHint: "Ce qui a compliqué l'action sans bloquer complètement.",
    w2Empechant: ["Fatigue", "Interruptions", "Téléphone", "Multitâche", "Manque de clarté"],
    w2BloquantTitle: "Ce qui a été bloquant",
    w2BloquantHint: "Ce qui a empêché l'action ou provoqué l'évitement.",
    w2Bloquant: ["Surcharge", "Anxiété", "Perfectionnisme", "Tâche trop floue", "Absence de priorité claire"],
    toWeek3: "Passer à la semaine 3",
    // Semaine 3
    w3Title: "Semaine 3 — Ajuster ses habitudes",
    w3Intro: "À partir de vos deux semaines d'observation, définissez vos principales priorités. On ne cherche pas la semaine parfaite, mais une semaine fonctionnelle — par essai et erreur, sans culpabilité.",
    w3PrioTitle: "Mes 3 priorités",
    w3PrioLabels: ["Priorité 1", "Priorité 2", "Priorité 3"],
    prioLevelsShort: ["Obligatoire aujourd'hui", "Important mais flexible", "Bonus"],
    energyChartTitle: "Énergie & charge mentale — Semaine 1",
    avgWord: "Moyenne de la semaine",
    badgesTitle: "Vos semaines complétées",
    badgeWeekDone: (n) => `Semaine ${n} complétée — bravo !`,
    programmeDoneTitle: "Programme terminé !",
    programmeDoneText: "Vous avez complété les 3 semaines du programme. Bravo pour votre régularité — c'est déjà une belle victoire.",
    w2FreqTitle: "Facteurs les plus fréquents — Semaine 2",
    w3PrioPh: "Ma priorité…",
    w3ToolsTitle: "Comprendre pour ajuster",
    w3ToolsHint: "Dépliez chaque repère pour mieux comprendre votre fonctionnement.",
    toEnd: "Terminer le programme",
    // Panneaux pédagogiques
    concepts: {
      motivationTitle: "Maintenir une motivation fonctionnelle",
      motivationPiege: "Le piège : le cerveau fonctionne souvent avec l'urgence, la pression et la culpabilité. Ça aide parfois à démarrer… mais ça épuise vite.",
      motivationBuildTitle: "Ce qu'on cherche à construire",
      motivationBuild: ["Commencer plus facilement", "Reprendre plus vite", "Maintenir un minimum", "Valoriser l'effort réel"],
      motivationRefTitle: "Reformuler ses pensées",
      motivationRefs: [
        { neg: "« Je n'ai fait que 10 minutes. »", pos: "« J'ai réussi à démarrer. »" },
        { neg: "« Je n'ai pas fini. »", pos: "« Je suis resté connecté à la tâche. »" },
        { neg: "« J'aurais dû faire plus. »", pos: "« J'ai évité l'évitement complet. »" },
      ],
      motivationMotto: "Faire un peu reste faire.",
      chargeTitle: "Diminuer la charge cognitive",
      chargeMotto: "Plus c'est flou, plus le cerveau évite.",
      chargeExpl: "Le cerveau ne bloque pas seulement sur la difficulté. Il bloque aussi sur le flou, les micro-décisions, trop d'étapes, trop d'informations, trop de choix.",
      chargeTransformTitle: "Transformer une tâche floue",
      chargeTransformFrom: "« Faire l'administratif »",
      chargeTransformSteps: ["Ouvrir l'ordinateur", "Ouvrir les mails", "Répondre à UN message"],
      chargeReduceTitle: "Réduire les questions mentales",
      chargeReduce: [
        { q: "« Par quoi je commence ? »", a: "Une seule étape" },
        { q: "« Comment faire parfaitement ? »", a: "Une seule priorité" },
        { q: "« Et si je changeais de méthode ? »", a: "Une seule décision à la fois" },
      ],
      chargeToolsTitle: "Outils utiles",
      chargeTools: ["Timers", "Check-lists courtes", "Objets visibles", "Routines fixes", "Préparation la veille", "Modèles pré-écrits"],
      prioTitle: "Gérer les priorités avec clarté",
      prioMotto: "Tout peut être important sans être prioritaire maintenant.",
      prioExpl: "Souvent, tout semble urgent — ou rien ne semble prioritaire. Résultat : dispersion, procrastination, surcharge, paralysie. La méthode des 3 niveaux apporte une réponse simple.",
      prioLevels: [
        { n: "1", label: "Priorité 1 — Obligatoire aujourd'hui", desc: "Si ce n'est pas fait : conséquence réelle. Maximum 1 à 3 tâches." },
        { n: "2", label: "Priorité 2 — Important mais flexible", desc: "Peut attendre ou être découpé en sous-étapes." },
        { n: "3", label: "Priorité 3 — Bonus", desc: "Seulement si énergie, temps et cerveau sont disponibles." },
      ],
      deadlineTitle: "La fausse deadline",
      deadlineExpl: "Le cerveau démarre difficilement les grosses tâches. On crée des mini-échéances. Exemple — dossier à rendre vendredi :",
      deadlineSteps: [
        { day: "Mardi", task: "Ouvrir le dossier" },
        { day: "Mercredi", task: "Faire le plan" },
        { day: "Jeudi", task: "Corriger" },
        { day: "Vendredi", task: "Envoyer ✅" },
      ],
      prioClosing: "Ce qu'on cherche vraiment : pas devenir parfaitement discipliné, mais construire un quotidien compatible avec son mode de fonctionnement et ses objectifs.",
    },
    boiteTitle: "Boîte à outils rapide",
    boiteIntro: "Quand ça ne fonctionne pas, ce n'est pas de la paresse ni un manque de motivation. C'est souvent une surcharge, une fatigue, une stratégie inadaptée ou une tâche trop floue.",
    boite: [
      { problem: "Je n'arrive pas à commencer", solutions: ["Timer 5 min", "Une seule étape", "Musique", "Enlever le téléphone"] },
      { problem: "Je suis submergé(e)", solutions: ["Écrire tout", "Choisir UNE priorité", "Supprimer 30 %", "Faire une pause"] },
      { problem: "Je procrastine", solutions: ["Rendre le point de départ visible", "Réduire la tâche", "Chercher le vrai blocage", "Tâche avant un moment plaisant"] },
    ],
    // done
    finishTitle: "Bravo pour ces 3 semaines",
    finishText: "Ce carnet est un support de réflexion. L'objectif n'est pas la perfection, mais un quotidien plus fonctionnel. Vous pouvez l'exporter en PDF pour en reparler avec votre praticien.",
    exportPdf: "Exporter en PDF",
    exporting: "Génération du PDF…",
    restart: "Recommencer",
    depotHint: "Votre praticien peut vous transmettre un lien de dépôt sécurisé : téléchargez d'abord le PDF, puis déposez-le via ce lien.",
    printTitle: "Programme 3 semaines — mon carnet",
    energyWord: "Énergie",
    noteWord: "Note",
    emptyDay: "—",
  },
  es: {
    allModules: "← Todos los módulos",
    welcomeTitle: "Programa de 3 semanas — 5 min/día",
    welcomeText: "Un programa pensado para tu cerebro, no contra él. Sin perfección, sin organización militar, sin métodos milagrosos. Solo 5 minutos al día para menos sobrecarga, más claridad y acciones realistas.",
    philoTitle: "En tres palabras",
    philo: ["Menos sobrecarga", "Más claridad", "Acciones realistas"],
    start: "Empezar",
    resumeTitle: "Retomar donde lo dejaste",
    resumeBtn: "Retomar",
    startOver: "Empezar desde el principio",
    avantTitle: "Antes de empezar",
    avantNotTitle: "NO buscamos",
    avantNot: ["Convertirnos en una máquina productiva", "Ser perfecto(a)", "Resolverlo todo en 3 semanas", "Eliminar todas las dificultades"],
    avantSeekTitle: "Buscamos",
    avantSeek: ["Reducir la carga mental", "Gestionar mejor las prioridades", "Disminuir la culpa", "Avanzar aunque sea de forma imperfecta"],
    avantNext: "Empezar la semana 1",
    weekWord: "Semana",
    dayWord: "Día",
    of: "de",
    prev: "Anterior",
    next: "Siguiente",
    otherPlaceholder: "Otro…",
    dayNotePlaceholder: "Una nota para hoy (opcional)…",
    saved: "Progreso guardado en este dispositivo",
    localTitle: "Sus semanas permanecen en este dispositivo",
    localText: "Nada se envía a un servidor: sus respuestas se guardan únicamente en este navegador, en este dispositivo. La conservación de las semanas registradas depende de usted: si cambia de dispositivo o de navegador, borra los datos de navegación o usa una ventana privada, el progreso no se recuperará. Descargue el cuaderno (PDF) al final de cada semana para conservar un registro.",
    w1Title: "Semana 1 — Observar sin juzgar",
    w1Intro: "Observa tu día a día sin intentar analizarlo todo. El objetivo: detectar los momentos positivos, identificar los difíciles y percibir mejor tu funcionamiento real. Sin juicio.",
    dailyRule: "5 minutos máximo — ni más, ni menos.",
    w1PositifTitle: "Lo que fue fácil / positivo",
    w1Positif: ["Conseguí empezar", "Momento de calma", "Buena energía", "Conversación agradable", "Tarea avanzada"],
    w1NegatifTitle: "Lo que fue difícil / negativo",
    w1Negatif: ["Cansancio", "Sobrecarga", "Procrastinación", "Distracciones", "Demasiada presión"],
    w1EnergyTitle: "Energía mental del día",
    w1EnergyHint: "Anota tu nivel de energía de 0 a 10.",
    w1ChargeTitle: "Carga mental del día",
    w1ChargeHint: "¿Hasta qué punto tenías la cabeza «llena» hoy? (0 = ligera, 10 = saturada)",
    chargeWord: "Carga",
    w1VictoireTitle: "Una pequeña victoria",
    w1Victoire: ["Respondí un mensaje", "Me duché", "Pedí ayuda", "Retomé tras una pausa"],
    toBilan: "Ver el balance de la semana",
    bilan1Title: "Fin de la Semana 1 — Balance",
    bilan1Text: "Tómate unos minutos para detectar los patrones de tu semana de observación.",
    bilan1Steps: [
      { t: "Detectar", d: "Identificar los patrones recurrentes" },
      { t: "Analizar", d: "Momentos fáciles y difíciles de la semana" },
      { t: "Elegir", d: "4 microajustes realistas" },
    ],
    bilan1PatternsLabel: "Los patrones que noto",
    bilan1PatternsPh: "Lo que se repite a menudo, tanto en positivo como en difícil…",
    bilan1AjustLabel: "Mis 4 microajustes para la semana siguiente",
    bilan1AjustPh: "Microajuste",
    bilan1Closing: "Este balance no es un examen. Es una brújula para entender mejor tu cerebro.",
    toWeek2: "Pasar a la semana 2",
    w2Title: "Semana 2 — Analizar tus hábitos",
    w2Intro: "Comprende qué ayuda, frena o bloquea realmente tu funcionamiento. El objetivo no es juzgarse, sino entender mejor los hábitos.",
    w2FacilitantTitle: "Lo que facilitó",
    w2FacilitantHint: "Lo que ayudó a empezar, avanzar, concentrarse o terminar.",
    w2Facilitant: ["Música", "Temporizador", "Entorno tranquilo", "Presencia de alguien", "Tarea dividida"],
    w2EmpechantTitle: "Lo que dificultó",
    w2EmpechantHint: "Lo que complicó la acción sin bloquearla del todo.",
    w2Empechant: ["Cansancio", "Interrupciones", "Teléfono", "Multitarea", "Falta de claridad"],
    w2BloquantTitle: "Lo que bloqueó",
    w2BloquantHint: "Lo que impidió la acción o provocó evitación.",
    w2Bloquant: ["Sobrecarga", "Ansiedad", "Perfeccionismo", "Tarea demasiado difusa", "Falta de prioridad clara"],
    toWeek3: "Pasar a la semana 3",
    w3Title: "Semana 3 — Ajustar tus hábitos",
    w3Intro: "A partir de tus dos semanas de observación, define tus principales prioridades. No buscamos la semana perfecta, sino una semana funcional — por ensayo y error, sin culpa.",
    w3PrioTitle: "Mis 3 prioridades",
    w3PrioLabels: ["Prioridad 1", "Prioridad 2", "Prioridad 3"],
    prioLevelsShort: ["Obligatorio hoy", "Importante pero flexible", "Bonus"],
    energyChartTitle: "Energía y carga mental — Semana 1",
    avgWord: "Media de la semana",
    badgesTitle: "Tus semanas completadas",
    badgeWeekDone: (n) => `¡Semana ${n} completada — enhorabuena!`,
    programmeDoneTitle: "¡Programa terminado!",
    programmeDoneText: "Has completado las 3 semanas del programa. Enhorabuena por tu constancia — ya es una gran victoria.",
    w2FreqTitle: "Factores más frecuentes — Semana 2",
    w3PrioPh: "Mi prioridad…",
    w3ToolsTitle: "Comprender para ajustar",
    w3ToolsHint: "Despliega cada punto para entender mejor tu funcionamiento.",
    toEnd: "Terminar el programa",
    concepts: {
      motivationTitle: "Mantener una motivación funcional",
      motivationPiege: "La trampa: el cerebro suele funcionar con la urgencia, la presión y la culpa. A veces ayuda a arrancar… pero agota rápido.",
      motivationBuildTitle: "Lo que buscamos construir",
      motivationBuild: ["Empezar más fácilmente", "Retomar más rápido", "Mantener un mínimo", "Valorar el esfuerzo real"],
      motivationRefTitle: "Reformular los pensamientos",
      motivationRefs: [
        { neg: "«Solo hice 10 minutos.»", pos: "«Conseguí arrancar.»" },
        { neg: "«No terminé.»", pos: "«Seguí conectado a la tarea.»" },
        { neg: "«Debería haber hecho más.»", pos: "«Evité la evitación total.»" },
      ],
      motivationMotto: "Hacer un poco sigue siendo hacer.",
      chargeTitle: "Disminuir la carga cognitiva",
      chargeMotto: "Cuanto más difuso, más evita el cerebro.",
      chargeExpl: "El cerebro no solo se bloquea con la dificultad. También se bloquea con lo difuso, las microdecisiones, demasiados pasos, demasiada información, demasiadas opciones.",
      chargeTransformTitle: "Transformar una tarea difusa",
      chargeTransformFrom: "«Hacer lo administrativo»",
      chargeTransformSteps: ["Abrir el ordenador", "Abrir los correos", "Responder a UN mensaje"],
      chargeReduceTitle: "Reducir las preguntas mentales",
      chargeReduce: [
        { q: "«¿Por dónde empiezo?»", a: "Un solo paso" },
        { q: "«¿Cómo hacerlo perfecto?»", a: "Una sola prioridad" },
        { q: "«¿Y si cambio de método?»", a: "Una sola decisión a la vez" },
      ],
      chargeToolsTitle: "Herramientas útiles",
      chargeTools: ["Temporizadores", "Listas cortas", "Objetos visibles", "Rutinas fijas", "Preparación la víspera", "Plantillas ya escritas"],
      prioTitle: "Gestionar las prioridades con claridad",
      prioMotto: "Todo puede ser importante sin ser prioritario ahora.",
      prioExpl: "A menudo todo parece urgente — o nada parece prioritario. Resultado: dispersión, procrastinación, sobrecarga, parálisis. El método de los 3 niveles ofrece una respuesta sencilla.",
      prioLevels: [
        { n: "1", label: "Prioridad 1 — Obligatorio hoy", desc: "Si no se hace: consecuencia real. Máximo 1 a 3 tareas." },
        { n: "2", label: "Prioridad 2 — Importante pero flexible", desc: "Puede esperar o dividirse en subpasos." },
        { n: "3", label: "Prioridad 3 — Bonus", desc: "Solo si hay energía, tiempo y cerebro disponibles." },
      ],
      deadlineTitle: "La falsa fecha límite",
      deadlineExpl: "Al cerebro le cuesta arrancar las tareas grandes. Creamos mini-plazos. Ejemplo — expediente a entregar el viernes:",
      deadlineSteps: [
        { day: "Martes", task: "Abrir el expediente" },
        { day: "Miércoles", task: "Hacer el esquema" },
        { day: "Jueves", task: "Corregir" },
        { day: "Viernes", task: "Enviar ✅" },
      ],
      prioClosing: "Lo que buscamos de verdad: no volverse perfectamente disciplinado, sino construir un día a día compatible con tu forma de funcionar y tus objetivos.",
    },
    boiteTitle: "Caja de herramientas rápida",
    boiteIntro: "Cuando no funciona, no es pereza ni falta de motivación. Suele ser sobrecarga, cansancio, una estrategia inadecuada o una tarea demasiado difusa.",
    boite: [
      { problem: "No consigo empezar", solutions: ["Temporizador 5 min", "Un solo paso", "Música", "Quitar el teléfono"] },
      { problem: "Estoy desbordado(a)", solutions: ["Escribirlo todo", "Elegir UNA prioridad", "Eliminar el 30 %", "Hacer una pausa"] },
      { problem: "Procrastino", solutions: ["Hacer visible el punto de partida", "Reducir la tarea", "Buscar el bloqueo real", "Tarea antes de un momento agradable"] },
    ],
    finishTitle: "Enhorabuena por estas 3 semanas",
    finishText: "Este cuaderno es un apoyo de reflexión. El objetivo no es la perfección, sino un día a día más funcional. Puedes exportarlo en PDF para comentarlo con tu profesional.",
    exportPdf: "Exportar en PDF",
    exporting: "Generando el PDF…",
    restart: "Reiniciar",
    depotHint: "Su profesional puede enviarle un enlace de depósito seguro: descargue primero el PDF y luego deposítelo mediante ese enlace.",
    printTitle: "Programa de 3 semanas — mi cuaderno",
    energyWord: "Energía",
    noteWord: "Nota",
    emptyDay: "—",
  },
};
